<template>
  <div class="previewwrap">
    <img v-if="showUrl && currentColor"
         :src="showUrl"
         class="showimg"
         :class="{bono:currentColor.s_color === 'ffffff' && currentColor.e_color==='ffffff'}"
         :style="{backgroundImage:'linear-gradient(to bottom,#'+currentColor.s_color+',#'+currentColor.e_color+')'}"
    />
    <div class="foot">
      <changeclose :colors="processedPhoto.backcolor"
                   :bgColor="bgColor"
                   @selIndex="selIndex"
                   :closeKey="closeKey"
                   @selkey="selkey"
                   :beautyFlag="beautyFlag"
                   @setbeauty="setbeauty"
      >
      </changeclose>
    </div>
    <div class="button-container" :class="{pad8:!this.showNoway}">
      <div :class="`elebtn bg_${platformInfo.skin} bs br_${platformInfo.skin}`" v-if="showEle" @click="eleFn">
        <img v-if="!canAdvertise" :src="require('@/assets/skins/'+platformInfo.skin+'/btn_price_tag@3x.png')" class="button-icon">
        <span v-if="canAdvertise&&showPrint || !canAdvertise">保存电子照</span>
        <div v-if="canAdvertise&&!showPrint">保存无水印电子照<p class="gkspgg">(观看视频广告)</p></div>
        <div class="advertiseinfo" :class="{showadvertise:showadvertise}" @click.stop="showadvertise=false">
          观看视频广告，保存电子照
          <img src="@/assets/icon_cancle@3x.png" class="close" />
        </div>
      </div>
      <!-- <div :class="`printbtn br_${platformInfo.skin} br-c_${platformInfo.skin} bg-font_${platformInfo.skin} {'onlyprint bg':!${showEle}}`" @click="print" v-if="showPrint" :class="{'onlyprint bg':!showEle}"> -->
      <div :class="`printbtn br_${platformInfo.skin} br-c_${platformInfo.skin} bg-font_${platformInfo.skin}`" @click="print" v-if="showPrint && showEle">
        <span>立即冲印</span><span class="zeng">（赠电子照）</span>
      </div>
      <div :class="`printbtn br_${platformInfo.skin} br-c_${platformInfo.skin} bg-font_${platformInfo.skin} onlyprint bg_${platformInfo.skin}`" @click="print" v-if="showPrint && !showEle">
        <span>立即冲印</span><span class="zeng">（赠电子照）</span>
      </div>
      <div class="iosnopay" v-if="showNoway">
        <img src="@/assets/pay_attention@3x.png" class="gantan" />
        由于相关规范，苹果手机保存电子照功能暂不可用
      </div>
    </div>
    <mt-popup
      v-model="showFlag"
      position="bottom"
      class="zd"
    >
    <selectz :showFlag="showFlag"
             :originpic="showUrl"
             :color="processedPhoto.backcolor"
             :colorIdx="bgColor"
             :closeKey="closeKey"
             :beautyFlag="beautyFlag"
             @closeflag="closeflag"
             @changezhengwu="changezhengwu"
             @elepay="elepay"
    >
    </selectz>
    </mt-popup>    
  </div>
</template>

<script>
import PhotoContainer from "@/components/PhotoContainer";
import changeclose from "@/components/changeclose/changeclose";
import selectz from "@/components/selectz/selectz";
import { parseBgColor } from "@/utils/utils";
import { mapState, mapMutations, mapActions } from "vuex";
import { alipay } from "@/utils/alipay";
import {
  Toast
} from "mint-ui";
import { setTimeout } from 'timers';
let eleSingleClick = true;//防连点
export default {
  components: {
    PhotoContainer,
    changeclose,
    selectz
  },
  data() {
    return {
      bgChoices: [],
      mutipleVisible:false,
      chosenWay:"mutiple",
      visited: localStorage.getItem("visited"),
      beautyFlag: true,
      isIos: /iphone|ipad|ipod|ios/i.test(navigator.userAgent),
      showadvertise: false,
      closeKey: "",
      showFlag: false,
      showUrl: ""
    };
  },
  created() {
    console.log(this.processedPhoto)
  },
  activated() {
    if(!this.actiBol){
      return;
    }
    (this.platformInfo.platform==="wechat" && !this.processedPhoto.picinfo.algo_fileuuid)||this.platformInfo.platform==="baidu"?this.wxgetPhoto().then(res=>{
      this.processedPhoto.picinfo = res.data;
      this.processedPhoto.picinfo.algo_fileuuid_beauty = res.data.algo_fileuuid;
      this.processedPhoto.picinfo.wm_url_beauty = res.data.wm_url;
      this.showUrl = res.data.wm_url[0]
      this.RECORD_PROCESSED_PHOTO(this.processedPhoto);
      this.showNoWayTip();
    }):this.showNoWayTip()
    this.showUrl = this.processedPhoto.picinfo.wm_url ? this.processedPhoto.picinfo.wm_url[0] : ""
    this.RECORD_SELECTED_BG(0)
    this.closeKey = "";
    this.beautyFlag = true;
  },
  methods: {
    ...mapMutations(["RECORD_SELECTED_BG", "RECORD_PRINTINFO", "RECORD_PROCESSED_PHOTO"]),
    ...mapActions(["wxgetPhoto","eleorder","asyncMakephotoJson","getorder","getWmPrintAndKey"]),
    changezhengwu(img) {
      this.showUrl = img;
    },
    closeflag(bol) {
      this.showFlag = bol;
    },
    uniformphoto (obj) {
      let ths = this;
      let closeKey = obj.hasOwnProperty("closeKey") ? obj.closeKey : ths.closeKey;
      let beautyFlag = obj.hasOwnProperty("beautyFlag") ? obj.beautyFlag : ths.beautyFlag;
      let data = {
        spec_id: ths.processedPhoto.specId,
        ...closeKey && { clothes_path: closeKey },
        level: beautyFlag ? "1" : "0",
        algo_fileuuid_origin: ths.processedPhoto.picinfo.algo_fileuuid_origin
      };
      ths.asyncMakephotoJson(data).then(res => {
        let keyname = Object.keys(obj)[0];
        ths.processedPhoto.picinfo.algo_fileuuid = res.data.algo_fileuuid;
        ths.processedPhoto.picinfo.wm_url = res.data.wm_url;
        ths.processedPhoto.picinfo.type="ordinary"
        ths.processedPhoto.picinfo.beauty_level=beautyFlag?1:0
        this.showUrl = res.data.wm_url[0];
        ths.RECORD_PROCESSED_PHOTO(ths.processedPhoto);
        ths[keyname]=obj[keyname];
      })
    },
    setbeauty(bol) {
      this.uniformphoto({beautyFlag:bol});
    },
    selkey(key) {
      this.uniformphoto({closeKey:key});
    },
    selIndex(idx) {
      this.RECORD_SELECTED_BG(idx)
    },
    showNoWayTip() {
      this.showPrint&&!this.showEle&&Toast({
        message: '由于相关规范，苹果手机保存电子照功能暂不可用', 
        duration: 3000
      })
    },
    closeMutiple(){
      this.mutipleVisible=false;
    },
    // showAdvertiseTip(){
    //   setTimeout(()=>{
    //     this.showadvertise = this.canAdvertise && this.showPrint;
    //   },2000)
    // },
    eleFn() {
      // this.canAdvertise?this.lookAdvertise():this.eleSel();
      this.eleSel();
    },
    elepay(data) {
      data.spec_id = this.processedPhoto.specId;
      data.ori_file_name = this.processedPhoto.picinfo.ori_file_name
      let {channel} = this.extraInfo
      if(channel){
        delete this.extraInfo.channel
        data.share_channel=channel
      }
      data.extra = this.extraInfo

      this.getorder(data).then(res => {
        this.showFlag = false
        let { data:{order_id,params:option} } = res;
        option.description = "gopay";
        option.platform = this.platformInfo.platform;
        option.orderId=order_id;
        this.sdk.gopay(`pages/miniApi/miniApi`,option);
      })
    },
    // lookAdvertise(){
    //   //TODO:暂时没有广告功能了下次有的时候再改
    //   //去看激励式广告
    //   if(!eleSingleClick){
    //     return;
    //   }
    //   eleSingleClick = false;
    //   //因为h5跳到微信页面该页面不会触发任何生命周期函数所以防连点只能通过计时器来设置
    //   setTimeout(()=>{
    //     eleSingleClick=true;
    //   },1000)
    //   let od = this.platformInfo.openid;
    //   let {spec_id,spec_name,ori_file_name} = this.processedPhoto;
    //   let url = `pages/miniApi/miniApi?description=advertisement&od=${od}&spec_id=${spec_id}&spec_name=${spec_name}&ori_file_name=${ori_file_name}&final_pic_name=${this.processedPhoto[this.finalbn][this.bgColor]}`;
    //   if (this.processedPhoto[this.finalprintbn].length > 0) {
    //     url += '&print_pic_name=' + this.processedPhoto[this.finalprintbn][this.bgColor];
    //   }
    //   this.sdk.lookAdvertise(url);
    // },
    eleSel() {
      //虚拟支付选择全背景还是单背景
      // console.log(this.processedPhoto.backcolor.length);
      let processedPhoto = this.processedPhoto;
      processedPhoto.backcolor.length > 1 || this.closeKey? this.showFlag = true : this.elepay({colors:processedPhoto.backcolor,fee:1,algo_fileuuid:processedPhoto.picinfo.algo_fileuuid});
    },
    // eleOrderPay(){
    //   let data = {
    //     spec_id: this.processedPhoto.spec_id,
    //     spec_name: this.processedPhoto.spec_name,
    //     ori_file_name: this.processedPhoto.ori_file_name,
    //     final_pic_name: this.chosenfinalbn,
    //     ...this.chosenfinalprintbn.length>0&&{print_pic_name: this.chosenfinalprintbn}
    //   }
    //   this.eleorder(data).then(res=>{
    //     //console.log(res);
    //     let { data:{order_id,params:option} } = res;
    //     option.description = "gopay";
    //     option.orderId=order_id;
    //     this.sdk.gopay(`pages/miniApi/miniApi`,option);
    //   })
    // },
    selType(type){
      this.chosenWay=type;
    },
    paynow(){
      this.mutipleVisible=false;
      this.eleOrderPay(this.chosenWay);
    },
    print() {
      let processedPhoto = this.processedPhoto;
      let data = {
        colors: [processedPhoto.backcolor[this.bgColor]],
        ...this.closeKey && {end_change_fm:processedPhoto.picinfo.algo_fileuuid},
        spec_id: processedPhoto.specId,
        first_pic_no_fm: this.beautyFlag ? processedPhoto.picinfo.algo_fileuuid_beauty : processedPhoto.picinfo.algo_fileuuid_no
      }
      let ths = this;
      this.getWmPrintAndKey(data).then(res => {
        let d = res.data;
        let printinfo = {
          sheets_number: d.number,
          origin: {
            imageUrl: d.bar_name_list_print_wm_url[0],
            serialNumber: data.first_pic_no_fm
          },
          ...d.bar_name_list_print_wm_url.length>1&&{
            formal: {
              imageUrl: d.bar_name_list_print_wm_url[1],
              serialNumber: processedPhoto.picinfo.algo_fileuuid
            },
          },
          spec_name: processedPhoto.specName,
          colors: processedPhoto.backcolor[ths.bgColor],
          origin_name: processedPhoto.picinfo.ori_file_name,
          spec_id: processedPhoto.specId
        };
        this.RECORD_PRINTINFO(printinfo);
        this.$router.push({
          name: "print"
        });
      })
    }
  },
  computed: {
    ...mapState(["specInfo", "orderInfo", "price","processedPhoto", "platformInfo","actiBol","bgColor","extraInfo"]),
    // showUrl() {
    //   return this.processedPhoto.picinfo && this.processedPhoto.picinfo.wm_url && this.processedPhoto.picinfo.wm_url[0]
    // },
    currentColor() {
      return this.processedPhoto.backcolor && this.processedPhoto.backcolor[this.bgColor];
    },
    originPrice() {
      return this.processedPhoto.background_color?(this.processedPhoto.background_color.length*2.99).toFixed(2):"计算中";
    },
    printFlag() {
      return this.processedPhoto.bar_name_list_print_wm_url&&this.processedPhoto.bar_name_list_print_wm_url.length > 0
    },
    // bgColor: {
    // 	get() {
    // 		return this.$store.state.bgColor;
    // 	},
    // 	set(val) {
    // 		this.RECORD_SELECTED_BG(val);
    // 	}
    // },
    showEle() {
      //是否显示电子照按钮
      return this.sdk.name === 'alipay'?true: !this.isIos?true: this.sdk.name === 'wechat'&&this.platformInfo.advertiseBol?true:false;
    },
    showPrint() {
      //是否显示冲印按钮
      return this.processedPhoto.print;
    },
    showNoway() {
      //是否显示在不能冲印不能虚拟支付的显示提示
      return !this.showPrint && !this.showEle;
    },
    canAdvertise() {
      //是否可以看广告
      return this.isIos && this.sdk.name === 'wechat' && this.platformInfo.advertiseBol;
    }
  }
};
</script>

<style lang="scss" scoped>
.foot {
  position: fixed;
  bottom: 0.6rem;
  width: 100%;
}
.zd {
  width: 100%;
}
.showimg {
  width: 2.18rem;
  border: 0.06rem solid white;
  box-sizing: content-box;
  display: block;
  margin: 0 auto 2.48rem;
}
.bono {
  border: none;
  margin-top: 0.06rem;
}
.zeng{
  font-size: 0.11rem;
}
.onlyprint{
  // background-color: #3E7DFF;
  color: #FFFFFF!important;
  margin-left: 0!important;
}
.previewwrap{
  padding-top: 0.35rem;
  position:relative;
  user-select: none;
  // margin-bottom: 2.48rem;
}
#single-button {
  width: 94.667vw;
  height: 0.45rem;
  // background: rgba(68, 128, 231, 1);
  // box-shadow: 0px 0.05rem 0.1rem 0px rgba(68, 128, 231, 0.25);
  // border-radius: 0.225rem;
  line-height: 0.45rem;
  color: white;
  font-size: 0.16rem;
  text-align: center;
  margin-left: 0.1rem;
  margin-top: 0.08rem;
}
.button-icon {
  width: 0.59rem;
  height: 0.45rem;
  position: absolute;
  top: 0;
  left: 0;
}
.iosnopay{
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FFF9F0;
  color: #F5A623;
  font-size: 0.14rem;
  flex-grow: 1;
}
.gantan{
  width: 0.16rem;
  height: 0.16rem;
  margin-right: 0.12rem;
}
.pad8{
  padding:0.08rem;
}
.elebtn{
  color: rgba(255, 255, 255, 1);
  flex-grow: 1;
  flex-shrink: 0;
  min-width: 48%;
  height: 0.45rem;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  font-size: 0.16rem;
  color: rgba(255, 255, 255, 1);
  position: relative;
}
.gkspgg{
  flex-basis: 100%;
  text-align: center;
  font-size: 0.11rem;
}
.advertiseinfo{
  position: absolute;
  top: -0.4rem;
  left: 0;
  text-align: center;
  line-height: 0.3rem;
  font-size: 0.13rem;
  color:#FFFFFF;
  padding: 0 0.1rem;
  height: 0.3rem;
  border-radius: 0.15rem;
  background-color: rgba(0,0,0,0.6);
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.5s linear;
  pointer-events: none;
}
.showadvertise {
  opacity: 1;
  pointer-events: all;
}
.advertiseinfo::after {
  content: '';
  display: block;
  width:0;
  height:0;
  border:0.06rem solid transparent;
  border-top-color: rgba(0,0,0,0.6);
  position:absolute;
  left:0.82rem;
  top:100%;
}
.close {
  width: 0.12rem;
  height: 0.12rem;
  vertical-align: middle;
  font-size: 0;
  margin-left: 0.04rem;
}
.printbtn{
  flex-grow: 1;
  flex-shrink: 0;
  min-width: 48%;
  height: 0.45rem;
  line-height: 0.45rem;
  font-size: 0.16rem;
  // color: rgba(68, 128, 231, 1);
  text-align: center;
  line-height: 0.45rem;
  margin-left: 0.09rem;
  // background: rgba(255, 255, 255, 1);
  // border-radius: 0.04rem;
  // border: 1px solid rgba(68, 128, 231, 1);
}
</style>